export type BrandProfileSidebarItem = {
  id: string;
  label: string;
  path: string;
};

export const BRAND_PROFILE_SIDEBAR_ITEMS: BrandProfileSidebarItem[] = [
  { id: 'basic', label: 'BASIC INFORMATION', path: 'basic' },
  { id: 'about', label: 'ABOUT', path: 'about' },
  { id: 'address', label: 'ADDRESS', path: 'location' },
  { id: 'cover', label: 'COVER AREA', path: 'cover' },
  { id: 'logo', label: 'LOGO', path: 'logo' },
  { id: 'gallery', label: 'GALLERY', path: 'gallery' },
  { id: 'social', label: 'SOCIAL MEDIA', path: 'social' },
  { id: 'media', label: 'MEDIA', path: 'media' },
  { id: 'gift-cards', label: 'GIFT CARDS', path: 'gift-cards' },
  { id: 'faqs', label: 'FAQs', path: 'faqs' }
];
